import { defaultRangePreset, rangePresets } from '@gogame/intl-ts';
import { array, object, string, number } from '@gogame/schemas';

import {
  FILTER_CREATED,
  FILTER_STATUSES,
  FILTER_SHOW,
  FILTER_TYPE,
  FILTER_AFFILIATES,
  FILTER_NETWORKS,
  FILTER_APPLICATIONS,
  FILTER_PLATFORMS,
  FILTER_CREATED_BY,
  MY_RULES,
} from 'scenes/SmartRules/constants';

export const filtersSchema = object({
  [FILTER_CREATED]: array(string())
    .default(rangePresets.LIFETIME.value)
    .constants(defaultRangePreset),
  [FILTER_STATUSES]: array(string()),
  [FILTER_SHOW]: string().default(MY_RULES),
  [FILTER_TYPE]: string(),
  [FILTER_AFFILIATES]: array(number()),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_PLATFORMS]: array(number()),
  [FILTER_CREATED_BY]: array(number()),
}).stripEmpty();

export const EMPTY_FILTERS = {
  ...filtersSchema.default(),
};
